/**
 * Created by neo on 21.01.2026
 * Support Section - Contains help and support options
 */
import * as React from 'react';
import { useCallback } from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { useTrans } from '../../Store/System/LocalizationStore';
import { Button } from '../../Components/Button';
import { Theme } from '../../Theme/Theme';

const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ActionCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const ActionInfo = styled.div`
  flex: 1;
`;

const ActionTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: ${Theme.Colors.textColor};
  margin: 0 0 4px 0;
`;

const ActionDescription = styled.p`
  font-size: 14px;
  color: ${Theme.Colors.charcoal};
  margin: 0;
`;

export const SupportSection: React.FC = observer(() => {
  const { t } = useTrans();
  const navigate = useNavigate();

  const handleGiveFeedback = useCallback(() => window.open('https://www.kinastic.com/kontakt', '_blank', 'noopener,noreferrer'), []);
  const handleContact = useCallback(() => navigate('/contact'), [navigate]);
  const handlePrivacy = useCallback(() => window.open('https://www.kinastic.com/privacy-policy', '_blank', 'noopener,noreferrer'), []);
  const handleTerms = useCallback(() => window.open('https://www.kinastic.com/agb-app', '_blank', 'noopener,noreferrer'), []);

  return (
    <SectionContent>
      <ActionCard>
        <ActionInfo>
          <ActionTitle>{t('accountScreen.support.feedback.title', { defaultValue: 'Send Feedback' })}</ActionTitle>
          <ActionDescription>
            {t('accountScreen.support.feedback.description', { defaultValue: 'Help us improve by sharing your thoughts' })}
          </ActionDescription>
        </ActionInfo>
        <Button color="primary" size="sm" onClick={handleGiveFeedback}>
          {t('accountScreen.giveFeedbackButton', { defaultValue: 'Give Feedback' })}
        </Button>
      </ActionCard>

      <ActionCard>
        <ActionInfo>
          <ActionTitle>{t('accountScreen.support.privacy.title', { defaultValue: 'Privacy Policy' })}</ActionTitle>
          <ActionDescription>
            {t('accountScreen.support.privacy.description', { defaultValue: 'Read our privacy policy' })}
          </ActionDescription>
        </ActionInfo>
        <Button color="secondary" size="sm" onClick={handlePrivacy}>
          {t('globals.view', { defaultValue: 'View' })}
        </Button>
      </ActionCard>

      <ActionCard>
        <ActionInfo>
          <ActionTitle>{t('accountScreen.support.terms.title', { defaultValue: 'Terms of Service' })}</ActionTitle>
          <ActionDescription>
            {t('accountScreen.support.terms.description', { defaultValue: 'Read our terms of service' })}
          </ActionDescription>
        </ActionInfo>
        <Button color="secondary" size="sm" onClick={handleTerms}>
          {t('globals.view', { defaultValue: 'View' })}
        </Button>
      </ActionCard>
    </SectionContent>
  );
});
